<input
	type="tel"
	maxlength="13"
	class="form-control"
	name="phone"
	[(ngModel)]="phone"
	(change)="changed()"
	pattern="/+[0-9]{12,}"
/>
<!-- <input type="tel" class="form-control col-sm-9" name="tel1" [(ngModel)]="lead.phone1" id="tel1" pattern="\+[0-9]{12,}"> -->
